import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ExtendDirection } from '@/modules/common';
import { invalidateTeamMemberRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { deleteTeamMemberChange } from '../api/team.api';
import { TeamMemberChangeType } from '../types/team-member-changes';

interface DeleteTeamMemberChangeParams {
  teamMemberId: number;
  section: TeamMemberChangeType;
  stateDeltaId: number;
  extendDirection: ExtendDirection;
}

export const useDeleteTeamMemberChange = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteTeamMemberChangeParams) => deleteTeamMemberChange(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['team-member-changes'] });
      // Deleting a scheduled change (capacity, billing, info, …) can alter member
      // state on any date, so the planner assignments and other member-derived
      // views must refresh — same fan-out the create/update change paths use.
      await invalidateTeamMemberRelatedQueries(queryClient);
    },
  });
};
